<template>
    <div class="form-elements">
        <div class="row" v-if="!download.load">
            <div class="col-md-6">
                <model-select :options="autoescolas" v-model="schema"
                    placeholder="Selecione uma autoescola"></model-select>
            </div>

            <div class="col-md-6">
                <button @click="getPraticasAgendadasHoje()" class="btn btn-dark btn-micro w-100">Gerar Planilha</button>
            </div>
        </div>

        <div v-else>
            <span class="d-flex justify-content-center mb-4">Pode demorar um pouco...</span>
            <div class="d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
                    </component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as spinners from 'epic-spinners'
import { ModelSelect } from 'vue-search-select'

export default {
    name: 'AgendadasHoje',
    components: {
        ...spinners,
        ModelSelect,
    },
    async created() {
        await this.buscarAutoescolas()
    },
    data() {
        return {
            autoescolas: [],
            schema: '',
            download: {
                load: false
            },
            dataInicial: '',
            dataFinal: ''
        }
    },
    methods: {
        async buscarAutoescolas() {
            await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/autoescola/todas`)
                .then(response => {
                    if (response.data.sucesso) {
                        this.autoescolas = response.data.dados.map(item => {
                            let schema = item.tenant_schema
                            return { text: item.nome_fantasia, value: schema }
                        })
                    }
                })
        },
        async getPraticasAgendadasHoje() {
            this.schema = this.schema ? this.schema : ''

            this.download.load = true

            await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/export/planilha/aulas/praticas/agendadas-hoje?autoescola=${this.schema}`)
                .then(response => {
                    var csv = 'data:text/csv;charset=utf-8,' + response.body.dados;
                    var dlnk = document.getElementById('downloadCSV');
                    dlnk.download = "praticas_agendadas_hoje.csv"
                    dlnk.href = csv;
                    dlnk.click();
                    this.download.load = false
                })
                .catch(err => {
                    this.launchToast('fa-warning', err.body.mensagem)
                })
                .finally(() => {
                    this.download.load = false
                })
        },
        launchToast(icon, msg) {
            this.$toasted.show(msg, {
                position: 'top-right',
                icon: icon
            });
        }

    }
}
</script>